export const PasswordStrength = {
  data() {
    return {
      dissatisfyMsg: "", // 密码强度不满足项
    };
  },
  methods: {
    // 判断包含种类
    isNum(str) {
      let num = 0;
      let arr = [];
      let reg1 = new RegExp(/\d/); // 包含数字
      let reg2 = new RegExp(/[a-z]/); // 包含小写字母
      let reg3 = new RegExp(/[A-Z]/); // 包含大写字母
      if (reg3.test(str)) {
        num = num + 1;
        arr.push("1");
        str = str.replace(/[A-Z]/g, "");
      }
      if (reg2.test(str)) {
        num = num + 1;
        arr.push("2");
        str = str.replace(/[a-z]/g, "");
      }
      if (reg1.test(str)) {
        num = num + 1;
        arr.push("3");
        str = str.replace(/\d/g, "");
      }
      if (str.length) {
        num = num + 1;
        arr.push("4");
      }
      return { num: num, text: arr.join(",") };
    },
    // 指定种类比较
    compareMethods(n, o) {
      let arr1 = n.split(",");
      let arr2 = o.split(",");
      console.log(arr1, arr2);
      let flag = true;
      let list = ["大写字母", "小写字母", "数字", "特殊字符"];
      for (let i = 0; i < arr2.length; i++) {
        let item = arr1.find((o) => o == arr2[i]);
        console.log(item);
        if (!item) {
          flag = false;
          this.dissatisfyMsg = list[arr2[i] - 1];
          console.log(this.dissatisfyMsg);
          break;
        } else {
          this.dissatisfyMsg = list[arr2[i] - 1];
          // this.dissatisfyMsg = "";
        }
      }
      console.log(this.dissatisfyMsg);
      return flag;
    },
    handleStrength(val) {
      console.log(val);
      if (!val) {
        this.form.passwordStrength = "";
        return "-";
      }
      let length = val.length;
      let obj = this.pswSetInfo;
      let obj2 = this.isNum(val);
      console.log(obj, obj2);
      if (
        obj.mmcl == 1 &&
        length >= obj.zlqmmgzcd &&
        obj2.num >= obj.zlqmmgzsl
      ) {
        this.form.passwordStrength = "3";
        return "强";
      }
      if (
        obj.mmcl == 2 &&
        length >= obj.tjqmmgzcd &&
        this.compareMethods(obj2.text, obj.tjqmmgzbh)
      ) {
        this.form.passwordStrength = "3";
        return "强";
      }
      if (
        obj.mmcl == 1 &&
        length >= obj.zlzmmgzcd &&
        obj2.num >= obj.zlzmmgzsl
      ) {
        this.form.passwordStrength = "2";
        return "中";
      }
      if (
        obj.mmcl == 2 &&
        length >= obj.tjzmmgzcd &&
        this.compareMethods(obj2.text, obj.tjzmmgzbh)
      ) {
        this.form.passwordStrength = "2";
        return "中";
      }
      if (
        obj.mmcl == 1 &&
        length >= obj.zlrmmgzcd &&
        obj2.num >= obj.zlrmmgzsl
      ) {
        console.log(
          111,
          obj.mmcl == 1,
          length >= obj.zlrmmgzcd,
          obj2.num >= obj.zlrmmgzsl
        );
        this.form.passwordStrength = "1";
        return "弱";
      }
      if (
        obj.mmcl == 2 &&
        length >= obj.tjrmmgzcd &&
        this.compareMethods(obj2.text, obj.tjrmmgzbh)
      ) {
        console.log(
          length >= obj.tjrmmgzcd,
          this.compareMethods(obj2.text, obj.tjrmmgzbh)
        );
        this.form.passwordStrength = "1";
        return "弱";
      }
      this.compareMethods(obj2.text, obj.tjrmmgzbh);
      this.form.passwordStrength = "";
      return "-";
    },
  },
};
